import Vue from 'vue'
import Vuetify from 'vuetify';
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import Clipboard from 'v-clipboard'
import linkify from 'vue-linkify';
import wysiwyg from "vue-wysiwyg";
import Loading from "./components/general/Loading";
import CopyField from "./components/general/CopyField";
import TreeView from "vue-json-tree-view";

Vue.config.productionTip = false

Vue.use(Clipboard);
Vue.use(wysiwyg, {});
Vue.use(TreeView);
Vue.directive('linkified', linkify);
Vue.component("Loading", Loading);
Vue.component("CopyField", CopyField);

Vue.prototype.$API_ENDPOINT = "https://api.schmuckli.cloud";

Vue.prototype.setTitle = function (title) {
  if (Vue.prototype._current_project_name === "" || Vue.prototype._current_project_name === undefined) {
    document.title = title + " - schmuckliCloud";
  } else {
    if (title === Vue.prototype._current_project_name) {
      document.title = title + " - schmuckliCloud";
    } else {
      document.title = title + " - " + Vue.prototype._current_project_name + " - schmuckliCloud";
    }
  }
};

new Vue({
  router,
  render: h => h(App),
  vuetify: new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#000',
          secondary: '#000',
          accent: '#8c9eff',
          error: '#b71c1c',
        },
        dark: {
          primary: '#fff',
          secondary: '#fff',
          accent: '#8c9eff',
          error: '#b71c1c',
        }
      },
    },
  })
}).$mount('#app')
